export default __webpack_public_path__ + "static/nail-salon-3d-cab9017d8268909e6cc127c8b797b703.svg";